<script>
import {actionType} from "@src/functions/reteEditor";


export default {
  props: ['freeze', 'fl_ai'],
  data() {
    return {
      btnsDisabled: false
    }
  },
  computed: {
    items: () =>
        Object.keys(actionType).map((action => {
          const item = {
            key: action,
            name: actionType[action]
          }
          switch (action) {
            case 'call': return {...item, icon: 'uil-outgoing-call', color: '#45B19F'}
            case 'audio_play': return {...item, icon: 'uil-play', color: '#72AF9D'}
            case 'speech_synthesis': return {...item, icon: 'uil-volume', color: '#32A0D4'}
            case 'audio_transcription': return {...item, icon: 'uil-edit-alt', color: '#BAA1DD'}
            case 'intent': return {...item, icon: 'uil-comment-verify', color: '#45B19F'}
            case 'goto': return {...item, icon: 'uil-expand-from-corner', color: '#489DC2'}
            case 'set_variables': return {...item, icon: 'uil-left-indent', color: '#E49C74'}
            case 'http_request': return {...item, icon: 'uil-cloud-upload', color: '#489DC2'}
            case 'audio_record': return {...item, icon: 'uil-microphone', color: '#EB9B6D'}
            case 'end_call': return {...item, icon: 'uil-phone-slash', color: '#E26A4F'}
            case 'ai_request': return {...item, icon: '', color: '#000000'}
            case 'event_wait': return {...item, icon: 'uil-sync', color: '#72AF9D'}            
            case 'message_send': return {...item, icon: 'uil-comment-lines', color: '#6D8EB9'}
            case 'call_redirect': return {...item, icon: 'uil-arrow-random', color: '#72AF9D'}
            case 'digital_input': return {...item, icon: '', color: '#72AF9D'}
            default: return {...item, icon: 'uil-phone-slash', color: '#E26A4F'}
          }
       }
      )
    ),
    session_user_item(){
        let session = this.$store.getters['sessions/GET_SESSIONS_ITEM'];
        return session.user ? session.user : null;
    },
  },
  methods: {
    addBlock(action) {
      this.$emit('addBlock', action)
    }
  }
}
</script>

<template>
  <div class="wrapper">
    <div class="doc-menu">

        <ul style="transition: all .3s">
          <!-- v-if="(item.key !== 'ai_request') || session_user_item.role === 'administrator'" -->
          <li
              style="transition: all .3s;"
              v-for="item in items"
              v-if="item.key !== 'ai_request' || fl_ai"
              v-show="item"
              :id="item.key + 'doc_item'"
              :key="item.key"
              v-b-tooltip.right="item.name"
              @click="!freeze ? addBlock(item.key) : null"
          >
            <div class="img-container">              
              <i v-if=" item.key !== 'set_variables' && item.key !== 'ai_request' && item.key !== 'digital_input' " :class="'feather uil ' + item.icon" :style="'display: flex; align-items: center; justify-content: center; font-size: 14px; ' + 'color: ' + item.color"></i>
              <span v-if=" item.key === 'set_variables' " :style="'font-size: 12px; font-weight: 700; ' + 'color: ' + item.color">$x</span>
              <span v-if=" item.key === 'ai_request' " :style="'font-size: 12px; font-weight: 700; ' + 'color: ' + item.color">AI.</span>
              <span v-if=" item.key === 'digital_input' " :style="'font-size: 12px; font-weight: 700; ' + 'color: ' + item.color">123</span>
            </div>
          </li>
          <!-- <li style="transition: all .3s;">
            <div class="img-container">
              <i class="feather uil uil-multiply" style="font-size: 16px"></i>
            </div>
          </li> -->
        </ul>

    </div>
  </div>

</template>

<style scoped>
  .wrapper {
    position: absolute;
    width: 43px;
    height: 100%;
    bottom: 0px;
    left: 20px;
    margin: auto;
    display: flex;
    align-items: center;
    z-index: 10;
    /*height: 100px;*/
  }

  .doc-menu {
    width: 100%;
  }

  .doc-menu ul {
    list-style-type: none;
    padding: 10px 0;
    margin-bottom: 0;
  }

  .doc-menu li {
    cursor: pointer;
    display: flex;
    /* position: absolute; */
    text-align: center;
    border-radius: 8px;
    background: white;
    box-shadow: 0 0 4px rgb(0 0 0 / 6%);
    margin: 7px;
    height: 40px;
    width: 100%;
  }

  .doc-menu li:last-child hr {
    display: none;
  }

  .img-container {
    width: 25px;
    height: 23px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: auto;
  }

  li:hover{
    background: #f5f4f4;
  }

  .divider {
    margin: 15px 0;
    width: 100%;
  }

  .icon{
    width: 18px;
    height: 18px;
    filter: brightness(0.9);
  }

  .icon.disabled {
    opacity: 0.5;
  }

</style>